import { decrypt } from '../utils/crypto';

const encryptedKeys = {
  GITHUB_TOKEN: '4300500acc4113e6e2848089d7fb0bdd:aee1038e245a068cb8d04c63f5ebe37a:RAZ9ZFogv6NVVH5QdggAaY0JT/kMfVWOcCkXBjwlRkj02WJoSxzcUJyoMIUFfO5r',
  EMAILJS_SERVICE_ID: '933cbe19966118c6556b6d685f315a00:1bba8524edff4865175f20ee4cecf857:34mnv7KjyOBUVfYrTmMdug==',
  EMAILJS_TEMPLATE_ID: '6acad9d8d746cd2798456f76b94eeb39:38e7f9656fd9a63cc6b291dd1f871d18:B7vYhjiOIEeOVv6q02MzZsmWEtGNwBW3eMPdqlB0kVg=',
  EMAILJS_PUBLIC_KEY: 'cdadd6bcdf8cd7bf453851e79be21404:77469c7ff2b2dc3a1858d282c9742525:TIz3zuIvtKwCam0xx0/iCe/vG7XY0H/OmNfmz/nO9Iw='
};

export const getKey = (keyName) => {
  try {
    const encryptedValue = encryptedKeys[keyName];
    if (!encryptedValue) return null;
    return decrypt(encryptedValue);
  } catch {
    return null;
  }
};